import Image from "next/image";
import { useRouter } from "next/router";


interface DiscoverMoreButtonProps {
  link: string;
}

const DiscoverMoreButton = (props: DiscoverMoreButtonProps) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(props.link);
  }

  return (
    <div
      className="w-fit items-center border border-[#2C3E2F] px-4 py-2 flex text-[10px] text-[#2C3E2F] font-montserrat cursor-pointer hover:border-[#A6BE9A] hover:bg-[#A6BE9A] hover:text-white justify-center"
      onClick={handleClick}
    >
      Discover more
      <Image
        src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/icon-arrow.png"}
        alt="arrow icon"
        width={12}
        height={12}
        quality={100}
        className="ml-2"
      />
    </div>
  )
}

export default DiscoverMoreButton
